import React from 'react';
import { observer } from 'mobx-react';
import { GridBooleanCellTemplate } from 'themes/components';

@observer
class GridBooleanCell extends React.Component {
    render() {
        return (
            <GridBooleanCellTemplate {...this.props}/>
        );
    }
}

export default GridBooleanCell;